if (!customElements.get('announcement-rotator')) {
  customElements.define('announcement-rotator', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.children);
      this.current = 0;
      this.hovered = false;
      this.focused = false;
      this.selected = false;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.controller = new AbortController();
      this.banner = this.closest('[data-announcement-sticky]');
      if (this.banner?.dataset.announcementSticky === 'true') {
        this.bannerObserver = new ResizeObserver(() => {
          document.documentElement.style.setProperty('--sticky-announcement-height', `${this.banner.offsetHeight}px`);
        });
        this.bannerObserver.observe(this.banner);
      }
      const options = {signal: this.controller.signal};
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', (event) => {
        this.focused = this.contains(event.relatedTarget);
        this.schedule();
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => this.schedule(), options);
      this.addEventListener('keydown', (event) => {
        if (event.target !== this || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.show(this.current + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.addEventListener('pointerdown', (event) => { this.pointerX = event.clientX; }, options);
      this.addEventListener('pointerup', (event) => {
        if (this.pointerX == null) return;
        const distance = event.clientX - this.pointerX;
        this.pointerX = null;
        if (Math.abs(distance) > 40) this.show(this.current + (distance < 0 ? 1 : -1));
      }, options);
      this.addEventListener('pointercancel', () => { this.pointerX = null; }, options);
      document.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (index < 0) return;
        this.selected = true;
        this.show(index);
      }, options);
      document.addEventListener('shopify:block:deselect', () => {
        this.selected = false;
        this.schedule();
      }, options);
      this.show(0);
    }

    disconnectedCallback() {
      clearTimeout(this.timeout);
      this.controller.abort();
      if (this.bannerObserver) {
        this.bannerObserver.disconnect();
        document.documentElement.style.removeProperty('--sticky-announcement-height');
      }
    }

    show(index) {
      if (!this.slides.length) return;
      this.current = (index + this.slides.length) % this.slides.length;
      this.style.setProperty('--announcement-offset', `${-100 * this.current}%`);
      this.slides.forEach((slide, i) => {
        slide.inert = i !== this.current;
        slide.setAttribute('aria-hidden', String(i !== this.current));
      });
      this.schedule();
    }

    schedule() {
      clearTimeout(this.timeout);
      if (this.slides.length < 2 || this.hovered || this.focused || this.selected || document.hidden || this.motion.matches) return;
      this.timeout = window.setTimeout(() => this.show(this.current + 1), Math.max(1, Number(this.dataset.speed) || 4) * 1000);
    }
  });
}
